import styled from '@emotion/styled'

const DetailsContainer = styled.div`
	${({ theme }) => `
	    display: flex;
		flex-direction: column;
        background: ${theme.palette.backgroundColors.darkGrey};
        border-radius: 8px;
        padding: 30px 24px;

        .key-value-container {
        	padding-bottom: 24px;

			&:last-child {
				padding-bottom: 0;
			}
        }
    `}
`

const DetailsSubContainer = styled.div`
	flex: 1;
`

const DetailsTitle = styled.div`
	${({ theme }) => `
	    font-size: 1rem;
	    color: ${theme.palette.fonts.primary};
	    padding-bottom: 24px;
    `}
`

export { DetailsContainer, DetailsSubContainer, DetailsTitle }
